import React from 'react';

import FourModuleLeftMenu from "./FourModuleLeftMenu";

const FourModuleTemplate = (props) => (
    <div className="four-container">
        <div className="container page">
            <FourModuleLeftMenu menus={props.menus}/>
            <div className="four-right">
                {props.children}
            </div>
        </div>
    </div>
)

export default FourModuleTemplate;